import '@src/knockoutExtensions/index';

import { HomeViewModel } from './pages/home/homeViewModel';
import { PricingAndOrdering } from './pages/pricingAndOrdering/pricingAndOrder';
import { MainMenu } from './controls/mainMenu';
import { LoggingViewModel } from './pages/sandbox/loggingViewModel';
import { ToastsViewModel } from './pages/sandbox/toastsViewModel';
import { CartViewModel as SandboxCartViewModel } from './pages/sandbox/cartViewModel';
import { CartViewModel } from './pages/cart/cartViewModel';
import { ContactUs } from './pages/contactUs/contactUs';

export = {
    HomeViewModel,
    PricingAndOrdering,
    CartViewModel,
    ContactUs,
    sandbox: {
        LoggingViewModel,
        ToastsViewModel,
        CartViewModel: SandboxCartViewModel,
    },
};

class App {
    start(){
        const mainMenu = new MainMenu();
        mainMenu.build();
    }
}
const app = new App();
$(() => app.start());